var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Tasks = YouLi.Trip.Tasks ? YouLi.Trip.Tasks : {};

(function (YouLi) {
    (function (Trip) {
        (function (Tasks) {

            YouLi.Trip.Tasks.FilterTasks = function () {
                if (YouLi.Trip.ShowCompleted) {
                    $(".tasks-accordion-item.completed:not('.completing')").show();
                }
                else {
                    $(".tasks-accordion-item.completed:not('.completing')").hide();
                }
                $(".filter-action-label").text(YouLi.Trip.ShowCompleted ? "Hide" : "Show");
            };

            YouLi.Trip.Tasks.TaskRespondFormSuccess = function (result) {

                var formSubmitBtn = $("form").find("button[type='submit']");
                YouLi.Common.UI.HideButtonLoading(formSubmitBtn);

                if (result.errors) {
                    $.each(result.errors, function (key, val) {
                        var container = $('span[data-valmsg-for="' + key + '"]');
                        container.removeClass("field-validation-valid").addClass("field-validation-error");
                        container.html(val[val.length - 1].ErrorMessage);

                        $(".field-validation-error").closest(".form-group").addClass("has-error").removeClass("has-success");
                    });

                    // update the summary as well
                    var summaryContainer = $('div[data-valmsg-summary=true]'),
                    list = summaryContainer.find("ul");
                    //summaryContainer.addClass("alert alert-danger");
                    if (list && list.length && result.errors) {
                        list.empty();
                        summaryContainer.addClass("validation-summary-errors").removeClass("validation-summary-valid");

                        $.each(result.errors, function () {
                            $("<li />").html(this[this.length - 1].ErrorMessage).appendTo(list);
                        });
                    }

                    $('#question-dialog').animate({ scrollTop: 0 }, 800);

                } else {
                    // get and restore collapsible panel states
                    var openPanelIds = $(".panel-collapse.collapse.in").map(function () { return this.id; }).get();
                    
                    $('#tasks-content').html(result.contentTasksHtml);
                    $('.trip-heading-title').html(result.tripHeadingTitle);
                    $('.trip-content-heading').html(result.tripContentHeadingHtml);

                    if ($('#content-trip-viewprofile').length > 0 && !$("#content-trip-viewprofile").hasClass("hidden")) {
                        $('#view-profile-content').html(result.currentInviteeProfileHtml);
                        $("#content-trip-viewprofile").removeClass("hidden");   // show it as it was previously being shown
                    }

                    RefreshInviteesTab(result.inviteesDetailsHtmlString, result.showInvitees);

                    if (YouLi.Trip.Payments != undefined)
                        YouLi.Trip.Payments.BillToEmail = result.currentInviteeEmail;

                    if (openPanelIds.length > 0) {
                        $('#' + openPanelIds.join(',#')).collapse("show");
                    }
                    YouLi.Trip.Tasks.FilterTasks();
                    $('#question-dialog').modal('hide');
                    $("#content-trip-tasks").toggleClass("hidden", YouLi.Trip.CurrentSection != "tasks");

                    setTimeout(function () {
                        // animate the hiding of the just-completed task (if it was completed)
                        if (!YouLi.Trip.ShowCompleted) {
                            $(".completing").fadeOut(1000, function () {
                                $(".completing").removeClass("completing");
                            });
                        }
                        else 
                        {
                            $(".completing").removeClass("completing");
                        }
                    }, 1000);

                    YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
                }

            };

            YouLi.Trip.Tasks.TaskRespondFormFailure = function (xhr, status, error) {
                var formSubmitBtn = $("form").find("button[type='submit']");
                YouLi.Common.UI.HideButtonLoading(formSubmitBtn);

                // update the summary with the error
                var summaryContainer = $('div[data-valmsg-summary=true]'),
                    list = summaryContainer.find("ul");
                if (list && list.length) {
                    list.empty();
                    summaryContainer.addClass("validation-summary-errors").removeClass("validation-summary-valid");

                    $("<li />").html(error).appendTo(list);
                }

                $('#question-dialog').animate({ scrollTop: 0 }, 800);
            };

            var RefreshInviteesTab = function (tabHTML, showInviteeTab) {
                if (showInviteeTab) {
                    // Display and refresh invitees tab (if not already displayed)
                    $(".content-tab-invitees").removeClass("hidden");

                    $("#invitees-content").html(tabHTML);

                    YouLi.Trip.SetupInviteeSectionMenu();
                }
            }

            $(function () {

                // Response functionality
                $(document).on("click touchstart", ".task-do-response", function () {

                    var taskItemId = $(this).data("task-item-id");
                    var inviteeId = $("#InviteeId").val();
                    var previewMode = $("#PreviewMode").val();

                    YouLi.Common.UI.ShowLoading();
                    $("#question-dialog-content").load('/trip/taskrespond?taskItemId=' + taskItemId + "&inviteeid=" + inviteeId + "&preview=" + previewMode, function (responseText, textStatus, XMLHttpRequest) {
                        YouLi.Common.UI.HideLoading();
                        if (textStatus == "error") {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred when loading response");
                        }
                        else {
                            $('#question-dialog').modal('show');
                        }
                    });
                });

                $(document).on("click", "#FilterTasks", function () {
                    // toggle filter
                    YouLi.Trip.ShowCompleted = !YouLi.Trip.ShowCompleted;
                    YouLi.Trip.Tasks.FilterTasks();
                });

                // initially hide or show completed, depending on number of tasks outstanding
                YouLi.Trip.Tasks.FilterTasks();

            });

        }(YouLi.Trip.Tasks ? YouLi.Trip.Tasks : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));
